<!-- <header [preLogin]="true"></header> -->
<header></header>
<div class="post-login-1">
    <div class="post-login-1-col-1 h-100">
        <app-left-panel-prelogin activeTab="2" *ngIf="this.auth?.detailuser == undefined"></app-left-panel-prelogin>
        <left-panel activeTab="2" *ngIf="this.auth?.detailuser != undefined"></left-panel>
    </div>
    <!-- <div class="pre-login"> -->
    <!-- <div class="pre-login-col-1 h-100">
        <app-left-panel-prelogin activeTab="2" *ngIf="!this.auth?.detailuser"></app-left-panel-prelogin>
        <left-panel activeTab="2" *ngIf="this.auth?.detailuser"></left-panel> 
       </div> -->
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas h-600">
            <grid-row class=" justify-content-center align-content-between h-100vh-80">
                <!-- <grid-row class=" justify-content-center align-content-between h-100"> -->
                <grid-col col="12">
                    <grid-row class="mt-30">
                        <grid-col col="12">
                            <div class="font-400 font-size-24px line-h-32 color-base-700">
                                {{ "NewTemporaryLimit" | translate }}
                            </div>
                            <div class="font-400 font-size-14px color-base-400 mt-10 line-h-22">
                                {{ "PleaseTemporaryLimit" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                </grid-col>
                <grid-col col="12">
                    <div class="text-align-center">
                        <div class="font-400 font-size-12px color-base-1500 line-h-20 letter-spacing-1 text-uppercase">
                            {{ "NewLimit" | translate }}
                        </div>
                        <div class="mt-10">
                            <span class="font-400 font-size-24px color-base-1500 line-h-24">{{"BHD" | translate}}</span>
                            <span class="font-600 font-size-24px color-base-1500 line-h-24">
                                {{this.cardService.AutoTempLimitObj.response.requestedLimit |amountFormatter}}
                            </span>
                        </div>
                        <div class="font-400 font-size-14px color-base-400 line-h-18 mt-5">
                            {{"CurrentLimit" | translate}}  {{"BHD" | translate}} 800.000
                        </div>
                        <div class="font-600 font-size-14px color-base-3000 line-h-20 letter-spacing-1 text-uppercase mt-20"
                            (click)="Edit()">
                            {{ "EditLimitAmount" | translate }}
                        </div>
                        <grid-row class="justify-content-center mt-20">
                            <grid-col col="12">
                                <div class="border border-color-ddd br-16">
                                    <grid-row class="">
                                        <grid-col col="6" class="border-right border-color-ddd">
                                            <div class="p-16">
                                                <div
                                                    class="font-400 font-size-12px color-base-1500 line-h-20 letter-spacing-1 text-uppercase">
                                                    {{ "StartDate" | translate }}
                                                </div>
                                                <div
                                                    class="font-600 font-size-14px color-base-1500 line-h-22 letter-spacing-03 mt-5">
                                                    {{this.cardService.AutoTempLimitObj.response.startDate | date: 'dd MMM yyyy'}}
                                                </div>
                                            </div>
                                        </grid-col>
                                        <grid-col col="6">
                                            <div class="p-16">
                                                <div
                                                    class="font-400 font-size-12px color-base-1500 line-h-20 letter-spacing-1 text-uppercase">
                                                    {{ "EndDate" | translate }}
                                                </div>
                                                <div
                                                    class="font-600 font-size-14px color-base-1500 line-h-22 letter-spacing-03 mt-5">
                                                    {{this.cardService.AutoTempLimitObj.response.endDate | date: 'dd MMM yyyy'}}
                                                </div>
                                            </div>
                                        </grid-col>
                                    </grid-row>
                                </div>
                            </grid-col>
                        </grid-row>
                    </div>
                </grid-col>
                <grid-col col="12">
                    <button class="btn-dft" (click)="showModal(2)">
                        {{ "Accept" | translate }}
                    </button>
                    <button class="btn-dft-border color-secondary mt-10" (click)="Decline()">
                        {{ "Decline" | translate }}
                    </button>
                </grid-col>
            </grid-row>

            <!-- 
                <div class="p-24 border border-color-900 br-16 box-shadow mt-50 text-align-center" *ngIf="this.cardService.AutoTempLimitObj">
                <div class="font-400 font-size-14px color-base-1500 line-h-20 text-uppercase">
                    {{"NewTemporaryLimit" | translate}}
                </div>
                <div class="font-600 font-size-24px color-base-1500 line-h-32 mt-8">
                    {{this.cardService.AutoTempLimitObj.response.requestedLimit}}
                    {{"BHD" | translate}} 1,000.000
                </div>
                <div class="font-400 font-size-14px color-base-400 line-h-18 mt-5">
                    {{"CurrentLimit" | translate}} {{"BHD" | translate}} 800.000
                </div>
                <div class="font-400 font-size-14px color-base-1500 line-h-20 text-uppercase mt-30">
                    {{"Duration" | translate}}
                </div>
                <div class="font-400 font-size-14px color-base-400 line-h-18 mt-5">
                    {{"StartDate"| translate}}
                </div>
                <div class="font-600 font-size-24px color-base-1500 line-h-32 mt-8">
                    3 Months{{this.cardService.AutoTempLimitObj.response.startDate | date: 'dd MMMM yyyy'}} 
                </div>
                <div class="font-400 font-size-14px color-base-400 line-h-18 mt-5">
                    {{"EndDate"| translate}} </div>
                <div class="font-600 font-size-24px color-base-1500 line-h-32 mt-8">
                    3 Months {{this.cardService.AutoTempLimitObj.response.endDate | date: 'dd MMMM YYYY'}}
                </div>
                <grid-row class="justify-content-between align-item-center mt-30">
                    <grid-col col="auto">
                        <button class="btn-dft-border w-170" [disabled]="true">
                             (click)="cardLimitPermanent()" 
                            {{ "INCREASE" | translate }}
                        </button>
                    </grid-col>
                    <grid-col col="auto">
                        <button class="btn-dft-border w-170 color-secondary" [routerLink]="['/CardLimitDecline']"
                            routerLinkActive="router-link-active">
                            {{ "Decline" | translate }}
                        </button>
                    </grid-col>
                </grid-row>
            </div>
            <grid-row class="justify-content-between align-item-center mt-50">
                <grid-col col="auto">
                    <div class="mt-15">
                        <button class="btn-back" (click)="back()">
                            <i class="icon-back"></i>
                        </button>
                    </div>
                </grid-col>
                <grid-col col="9">
                    <button class="btn-dft" (click)="showModal(2)">
                        {{ "Accept" | translate }}
                    </button>
                </grid-col>
            </grid-row> -->

        </div>
    </div>
</div>

<!-- Change Card -->
<modal modalID="2" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONFIRM"
    [whiteButtonStatus]="true" whiteButtonText="cancel" (doneButton)="AcceptLimit()">
    <div class="text-align-center">
        <ng-icon iconClass="icon-card-limit" width="77" height="72"></ng-icon>
        <div class="font-size-20px color-base-1300 font-400 line-h-25 mt-30 letter-spacing-03">
            {{"SetNewLimit" | translate}}
        </div>
        <!-- <div class="mt-10">
            <span class="font-400 line-h-25 color-base-500">
                {{"YouwantCardLimit" | translate}}
            </span>
            <strong class="color-base-700 line-h-25">
                {{"BHD" | translate}} 500.000 
            </strong>
            <span class="font-400 line-h-25 color-base-500">
               ?
            </span>
        </div> -->
        <div class="mt-10">
            <span class="font-400 line-h-25 color-base-500">
                {{"AreSureWantIncrease" | translate}}
            </span>
            <strong class="color-base-700 line-h-25">
                {{"BHD" | translate}} {{this.cardService.AutoTempLimitObj.response.requestedLimit |amountFormatter}} ?
            </strong>
            <span class="font-400 line-h-25 color-base-500">
            </span>
        </div>
    </div>
</modal>